export default ({
  STATS: 'statistics_monitoring',
  TICKETS: 'tickets_monitoring',
})
